// @ts-nocheck
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { createContext, useContext } from "react";
import React from "react";
import { css, useTheme } from "styled-components";

interface CardStyles {
    body: InjectableCss;
    header: InjectableCss;
    footer: InjectableCss;
}

const useCardStyles = (
    variant?: keyof Toolkit.Theme.Card["variants"],
    size?: keyof Toolkit.Theme.Card["sizes"],
): CardStyles | null => {
    const theme = useTheme();
    if (!theme) {
        return null;
    }
    const selectedVariant = variant ? theme.card.variants[variant] : theme.card.variants["elevated"];
    const sizeVariant = size ? theme.card.sizes[size] : theme.card.sizes["medium"];
    return {
        body: {
            css: css`
                ${sizeVariant?.css}
                ${selectedVariant.body?.css}
                border-radius: 0;
            `,
        },
        header: {
            css: css`
                ${sizeVariant?.css}
                ${selectedVariant.header?.css}
                border-radius: 0;
            `,
        },
        footer: {
            css: css`
                ${sizeVariant?.css}
                ${selectedVariant.footer?.css}
                border-radius: 0;
            `,
        },
    };
};

export const cardContext = createContext<ReturnType<typeof useCardStyles> | null>(null);
interface CardStylesProviderProps {
    variant?: keyof Toolkit.Theme.Card["variants"];
    size?: keyof Toolkit.Theme.Card["sizes"];
    children: React.ReactNode;
}
export const CardStylesProvider: React.FC<CardStylesProviderProps> = ({ variant, size, children }) => {
    const cardStyles = useCardStyles(variant, size);
    return <cardContext.Provider value={cardStyles}>{children}</cardContext.Provider>;
};

const useCardStylesConsumer = () => {
    const cardStyles = useContext(cardContext);
    if (!cardStyles) {
        throw new Error("CardStylesConsumer must be used within a CardStylesProvider");
    }
    return cardStyles;
};

export default useCardStylesConsumer;
